import { useState, useEffect } from 'react'

export const useCountdown = (initialCount) => {
  const [count, setCount] = useState(initialCount)

  const resetCountdown = () => {
    setCount(initialCount)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (count === 0) {
        clearInterval(interval)
      } else {
        setCount((prevCount) => prevCount - 1)
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [count])

  return {
    count,
    resetCountdown,
  }
}
